@if (question$ | async; as question) {
  <ng-container (ngSubmit)="handleExerciseSubmit(question.quiz)">
    @if (!question.quiz.score.is_complete) {
      @if (withTimer) {
        <div class="timer">
          {{ time }}
        </div>
      }
      <lib-progress-bar-text
        class="progress"
        [length]="question.quiz.score.total"
        [current]="question.quiz.score.answered"
        textPosition="top"
      ></lib-progress-bar-text>
      @if (!wasFullScreenReadingClosed && readingText) {
        <div class="full-screen-reading">
          @if (readingAudio?.url1x) {
            <lib-speaker-btn class="speaker-btn" [audioSrc]="readingAudio.url1x"></lib-speaker-btn>
          }
          <div class="reading-text" [innerHTML]="readingText | safe: 'html'"></div>
          <button class="btn secondary h-lg" (click)="handleGoToQuestionsClick(question.quiz.shop_quiz_session_id)">
            {{ 'exercises.go_to_questions' | transloco }}
          </button>
        </div>
      } @else {
        @if (readingText) {
          <button (click)="handleOpenText(readingText)" class="btn basic w-xsm h-sm open-text-btn">
            <span class="icon book" inlineSVG="/icons/icon-book-current-color.svg"></span>
            <span>{{ 'exercises.open_text' | transloco }}</span>
          </button>
        }
        <div class="question-desc" [innerHTML]="question.quiz.question.description | safe: 'html'"></div>
        @if (question.quiz.question?.audio?.url1x) {
          <lib-speaker-btn class="speaker" [audioSrc]="question.quiz.question.audio?.url1x"></lib-speaker-btn>
        }
        @if (question.quiz.question?.photo?.url1x) {
          <div>
            <img
              [src]="question.quiz.question.photo.url1x"
              [alt]="$safeNavigationMigration(question.quiz.question.photo?.alt)"
            />
          </div>
        }
        <div class="answer-container">
          @switch (question.quiz.question.type) {
            @case (QuizQuestionType.Single) {
              <div>
                <lsl-single-exercise
                  [answers]="question.quiz.question.answers"
                  [form]="form"
                  [answerValidation]="question.quiz.answer"
                  [validAnswers]="question.quiz.answers_valid"
                ></lsl-single-exercise>
              </div>
            }
            @case (QuizQuestionType.Order) {
              <div>
                <lsl-order-exercise
                  [form]="form"
                  [answers]="question.quiz.question.answers"
                  [answerValidation]="question.quiz.answer"
                  [(reset)]="reset"
                ></lsl-order-exercise>
              </div>
            }
            @case (QuizQuestionType.Text) {
              <div>
                <lsl-text-exercise [form]="form" [answerValidation]="question.quiz.answer"></lsl-text-exercise>
              </div>
            }
          }
        </div>
        <div class="info-container">
          @if (question.quiz.answer && question.quiz.answer.valid) {
            <div class="correct info">
              <h5>
                <span class="icon info" inlineSVG="/icons/icon-success-3-current-color.svg"></span>
                <b>{{ 'exercises.good_job' | transloco }}</b>
              </h5>
            </div>
          }
          @if (question.quiz.answer && !question.quiz.answer.valid) {
            <div class="incorrect info">
              <h5 class="title">
                <span class="icon info" inlineSVG="/icons/icon-cancel-current-color.svg"></span>
                <b>{{ 'exercises.incorrect' | transloco }}</b>
              </h5>
              @if (question.quiz.answers_valid[0]?.text) {
                <p>
                  <span>{{ 'exercises.correct_answer' | transloco }}: </span
                  ><u><span [innerHTML]="question.quiz.answers_valid[0]?.text | safe: 'html'"></span></u>
                </p>
              }
              @if (question.quiz.answers_valid[0]?.explanation) {
                <p [innerHTML]="question.quiz.answers_valid[0]?.explanation | safe: 'html'"></p>
              }
            </div>
          }
        </div>
        @if (question.quiz.answer || endOfTime) {
          <button type="submit" class="btn secondary h-lg w-md" (click)="nextQuestion(question.quiz)">
            {{ 'exercises.next' | transloco }}
          </button>
        }
        @if (!question.quiz.answer && !endOfTime) {
          <button type="submit" class="btn secondary h-lg w-md" (click)="handleExerciseSubmit(question.quiz)">
            {{ 'exercises.submit' | transloco }}
          </button>
        }
      }
    } @else {
      <lsl-result
        [replayable]="question.exercise.replayable"
        [isExam]="!question.exercise.not_timed"
        [quizSessionScore]="question.quiz.score"
        (restartExercise)="restartExercise($event)"
        (continueClick)="handleContinue($event, question.quiz.score.is_passed)"
      ></lsl-result>
    }
  </ng-container>
} @else {
  <div class="spinner-container p-absolute">
    <mat-spinner [diameter]="30"> </mat-spinner>
  </div>
}
